<template>
  <div
    v-if="index > -1"
    style="display:inline-flex"
  >
    <div style="width:40px">
      <b-img
        v-for="(item, index) in $parent.data[index].pictutes"
        :key="index"
        :src="item"
        width="40px"
        height="40px"
        class="postcard"
        @click="imagesrc=item"
      />
    </div>
    <b-card
      border-variant="light"
      header-border-variant="light"
      header-variant="light"
      no-body
    >
      <b-row no-gutters>
        <b-col md="6">
          <b-card-img :src="imagesrc"/>
        </b-col>
        <b-col md="6">
          <b-card-body>
            <b-card-text>
              <h3>{{ $parent.data[index].title }}</h3>
              <h5><i>{{ $parent.data[index].subtitle }}</i></h5>
            </b-card-text>
            <b-card-text>
              {{ $parent.data[index].details }}
            </b-card-text>
            <b-card-text>
              <b>Veľkosť: </b>{{ $parent.data[index].size }}
            </b-card-text>
            <b-card-text>
              <b>Materiál: </b>{{ $parent.data[index].material }}
            </b-card-text>
            <b-card-text>
              <b>Spôsob výroby: </b>{{ $parent.data[index].kind }}
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Details',
  components: {
    'postcard': Picture
  },
  setup(props, context) {
    const imagesrc = ref("")
    const index = ref(context.parent.data.findIndex(value => value.id == context.root.$route.params.id))
    if (index.value > -1) {
      imagesrc.value = context.parent.data[index.value].pictutes[0]
      //console.log(document.getElementById('myManifest'))
      //document.querySelector('head meta[property="og:image"]').content = "./" + imagesrc.value
      //document.querySelector('head meta[property="og:image:url"]').content = "https://misha-cards-app" + imagesrc.value
      /*console.log(document.querySelector('head meta[property="og:image"]'))
      console.log(context.root.$route.query)
      if (context.root.$route.query.reload == "true") {
        let href = window.location.href
        window.location.href = href.replace("?reload=true", "")
        localStorage.setItem('misha-cards', "." + imagesrc.value)
        window.location.reload()
      }*/
      //window.location.reload()
      //document.getElementById('myManifest').content = imagesrc.value
    } else {
      context.root.$router.push('/nenajdena')
    }
    return {
      imagesrc,
      index
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Details.vue